import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import { setstartup} from '../modules/toolpanelstore';
import { setsearchstartup } from '../modules/searchliststore';
import { showlimitset } from '../modules/toolpanelstore';
import { isEmpty } from '../modules/appLibrary';
import { opentheme } from '../modules/formstore';

export default function CustomToolPanel(props) {
    const mainlayout = useSelector(state => state.toolpnl.layouts);         //Main List
    const mainprelayout = useSelector(state => state.toolpnl.prelayout);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout);
    const mainshowlimit = useSelector(state => state.toolpnl.showlimit);
    const mainfitColumn = useSelector(state => state.toolpnl.fitColumn);
    const searchlayout = useSelector(state => state.search.layouts);        //Search List
    const searchprelayout = useSelector(state => state.search.prelayout);
    const searchinitlayout = useSelector(state => state.search.initlayout);
    const searchshowlimit = useSelector(state => state.search.showlimit);
    const searchfitColumn = useSelector(state => state.search.fitColumn);
    const searchusePanel = useSelector(state => state.search.useSearchPanel);
    const admin = useSelector(state => state.user.authority);
    const tabs = useSelector(state => state.form.listtabs);
    const dispatch = useDispatch();

    const [useSearchPanel, setuseSearchPanel] = useState(false);
    const [initlayout, setinitlayout] = useState(' ');
    const [showlimit, setshowlimit] = useState('2');
    const [prelayout, setprelayout] = useState("0");
    const [fitColumn, setfitColumn] = useState(false);
    const [layouts, setlayouts] = useState([{ value: ' ', label: '既定レイアウト' }]);
    //const limits = [
    //    { value: '0', label: '起動時表示しない' },
    //    { value: '1', label: '1000件'},
    //    { value: '2', label: '5000件' },
    //    { value: '3', label: '10000件' },
    //    { value: '9', label: '全件' },
    //];
    const limits = [
        { value: '1', label: '1000件' },
        { value: '2', label: '5000件' },
        { value: '3', label: '10000件' },
        { value: '9', label: '全件' },
    ];

    useEffect(() => {
        if (isEmpty(mainlayout) || Number(props.type)===1000) return;
        setlayouts(mainlayout);
    }, [mainlayout]);
    useEffect(() => {
        if (isEmpty(mainprelayout) || Number(props.type) === 1000) return;
        setprelayout(mainprelayout?"0":"1");
        setinitlayout(maininitlayout);
        setshowlimit(mainshowlimit);
        setfitColumn(mainfitColumn);
    }, [mainprelayout]);

    useEffect(() => {
        if (isEmpty(searchlayout) || Number(props.type) !== 1000) return;
        setlayouts(searchlayout);
    }, [searchlayout]);

    useEffect(() => {
        if (isEmpty(searchlayout) || Number(props.type) !== 1000) return;
        setprelayout(searchprelayout?"0":"1");
        setinitlayout(searchinitlayout);
        setshowlimit(searchshowlimit);
        setfitColumn(searchfitColumn);
    }, [searchprelayout, searchinitlayout, searchshowlimit, searchfitColumn]);

    useEffect(() => {
        setuseSearchPanel(Number(props.type) !== 1000?props.useSearchPanel: searchusePanel);
    }, [props.useSearchPanel, searchusePanel]);

    function share() {
       props.applycolumn();
       props.fnc.current.formdialogopen(
            {
                title: "メニュの共有", dialogtype: 9,
                contents: "現在のリストレイアウトを共有します。※EntryFormは対象外",
                contents2: "共有する条件を指定し「実行」をクリックすると担当者に新規メニュが配布されます。",
                textarea: false,
                customcontents: 1,  //共有条件
                onApply: (param) => Action(param)
            });
        function Action(param) {
            if (param.option !== "0" && isEmpty(param.codes)) {
                props.fnc.current.warnmsg("共有条件が未入力です");
                return;
            }
            let colDefs = props.getcoldef();
            props.fnc.current.postaxios('menu/ShareMenu',
                {
                    controller: props.dataid,
                    subkey: props.subkey,
                    type: param.option,
                    code: param.codes,
                    coldefs: colDefs,
                    tabs: tabs,
                },
                {
                    onSuccess: function (data) {
                        props.fnc.current.formdialogclose();
                        props.fnc.current.success();
                        props.fnc.current.wait(false);
                    },
                }
            )
        }
    }

    function Changeshowlimit(e) {
        setshowlimit(e.target.value);
        dispatch(showlimitset(e.target.value));
    }
    function settingexec() {
        props.applycolumn();
        props.fnc.current.confmsg("起動時設定を登録します。よろしいですか？", ()=>SavePropaty());
    }
    function SavePropaty() {
        props.fnc.current.postaxios('common/SaveStartupPropaty',
            {
                "controller": props.dataid, "subkey": props.subkey, "type": props.type,
                "prelayout": prelayout==="0"?true:false,
                "initlayout": initlayout,
                "showlimit": showlimit,
                "fitColumn": fitColumn
            },
            {
                onSuccess: function (data) {
                    if (Number(props.type) === 1000) {
                        dispatch(setsearchstartup({
                            prelayout: prelayout === "0",
                            initlayout: initlayout,
                            showlimit: showlimit,
                            fitColumn: fitColumn
                        }));
                    } else {
                        dispatch(setstartup({
                            prelayout: prelayout === "0",
                            initlayout: initlayout,
                            showlimit: showlimit,
                            fitColumn: fitColumn
                        }));
                    }
                    props.fnc.current.success();
                    props.fnc.current.wait(false);
                },
            }
        )
    }
    function sortreset() {
        props.api.applyColumnState({ defaultState: { sort: null } });
    }
    function filterclear() {
        props.api.setFilterModel(null);
    }
    function fitcolwidth(skip) {
        var allColumnIds = [];
        props.api.getAllGridColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
        });
        props.api.autoSizeColumns(allColumnIds, skip);
    }

    return (
         <List
            sx={{ width: '100%', bgcolor: 'background.paper' }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            subheader={
                <ListSubheader component="div" id="nested-list-subheader">
                    Tool Menu / Setting
                </ListSubheader>
            }
        >
            <ListItem button onClick={sortreset}>
                <ListItemText primary="並び替えをリセット" />
            </ListItem>
            <ListItem button onClick={filterclear}>
                 <ListItemText primary="フィルタ条件をクリア" />
            </ListItem>
            <ListItem button onClick={()=>fitcolwidth(false)}>
                <ListItemText primary="列幅を最適化（ヘッダ含む）" />
            </ListItem>
            <ListItem button onClick={() => fitcolwidth(true)}>
                <ListItemText primary="列幅を最適化（データのみ）" />
            </ListItem>
            <Divider />
            {Number(props.type) !== 1000 ?
                <React.Fragment>
                <ListItem button onClick={() => dispatch(opentheme(true))}>
                    <ListItemText primary="テーマ設定" />
                </ListItem>
                <Divider />
                </React.Fragment>
                : null}
            <ListItem>
                <ListItemText primary="起動時設定" />
                <Button variant="outlined" size="small" onClick={settingexec}>設定</Button>
            </ListItem>
                <ListItem>
                    <RadioGroup
                         name="initlayout"
                        value={prelayout}
                        onChange={(e) => setprelayout(e.target.value)}
                    >
                        <FormControlLabel value="0"
                            control={<Radio size="small" />}
                            label={<span style={{ fontSize: 12 }}>前回レイアウトを表示</span>}
                        />
                        <FormControlLabel value="1"
                            control={<Radio size="small" />}
                            label={<span style={{ fontSize: 12 }}>レイアウト指定</span>}
                        />
                    </RadioGroup>
               </ListItem>
                <ListItem style={{ marginBottom: 10 }}>
                    <TextField
                        select
                        label=""
                        value={initlayout}
                        fullWidth
                    onChange={(e)=>setinitlayout(e.target.value)}
                    >
                        {layouts.map((option) => (
                            <MenuItem key={option.value} value={option.value} style={{ fontSize: 10 }}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </ListItem>
                <ListItem>
                <FormControlLabel
                    control={<Checkbox size="small" checked={fitColumn} onChange={(e) => setfitColumn(e.target.checked)}/>}
                    label={<span style={{ fontSize: 12 }}>列幅を最適化する</span>}
                />
            </ListItem>
            <Divider />
           {useSearchPanel ?
                <React.Fragment>
                    <ListItem>
                        <ListItemText primary="起動時表示制限数" />
                    </ListItem>
                    <ListItem style={{ marginBottom: 10 }}>
                        <TextField
                            select
                            label=""
                            value={showlimit}
                            fullWidth
                            onChange={Changeshowlimit}
                        >
                            {limits.map((option) => (
                                <MenuItem key={option.value} value={option.value} style={{ fontSize: 10 }}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </ListItem>
                </React.Fragment>
                : null}
            <Divider />
            {admin === "1" && Number(props.type) !== 1000 ?
                <ListItem button onClick={share}>
                    <ListItemText primary="現在のレイアウトを共有" />
                </ListItem>
                : null}

         </List>
    );
};